<template>
	<div
		aria-hidden="true"
		aria-labelledby="modalFillInLabel"
		class="modal animation opacity modal-default modal-upload modal-knowledgebase modal-unit"
		:id="'modal-unit-' + type.name"
		role="dialog"
		tabindex="-1"
	>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div>
						<strong>{{ __('units.' + type.name + '.name') }}</strong>

						<button aria-hidden="true" class="close" data-dismiss="modal" type="button">
							<svg-icon icon="close-modal" />
						</button>
					</div>
				</div>

				<div class="modal-body">
					<header>
						<h2>{{ __('units.' + type.name + '.title') }}</h2>
						<p v-if="type.name === 'hemoglobin'">
							{{
								__(
									'HbA1c, or glycated haemoglobin, is an indicator of the long-term compensation of your diabetes. Choose the unit you want to use in the app.'
								)
							}}
						</p>
					</header>

					<unit-modal-input
						v-for="unit in data"
						:key="unit.id"
						:type="type"
						:unit="unit"
						@unit="setUnit"
					></unit-modal-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import UnitModalInput from './UnitModalInput.vue'

	export default {
		components: {
			UnitModalInput
		},
		props: {
			type: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				data: {}
			}
		},
		mounted() {
			this.fetch()

			console.log(this.user)
		},
		methods: {
			fetch() {
				var that = this
				axios
					.get(`/api/units/${this.type.name}`, {
						headers: { 'Accept-Language': _.get(window, 'locale', 'cs') }
					})
					.then((r) => {
						this.data = r.data.data
					})
					.catch((e) => {
						console.error(e)
					})
			},
			setUnit(unit) {
				this.$emit('unit', unit)
			}
		}
	}
</script>
